import { LandingPageProjectInfo } from '@models/projects.model'
import { Box, Grid, useMediaQuery } from '@mui/material'
import { Stack } from '@mui/system'
import { ComponentIcon } from './ComponentIcon'

interface ComponentListProps {
	markerElem: LandingPageProjectInfo
}

export const ComponentList = ({ markerElem }: ComponentListProps) => {
	const components = markerElem['product_modules']
	const isSmallScreen = useMediaQuery('(max-width:1180px)')
	const projectId = markerElem['id']

	return (
		<Box
			sx={{
				width: '100%',
				height: '270px',
				margin: '10px 0 10px 0',
			}}
		>
			<Grid container columnSpacing={isSmallScreen ? 0 : 3} rowSpacing={isSmallScreen ? 0 : 2}>
				{components
					?.filter((x) => x.code === 'Varadise Twin')
					?.map((component) => {
						return (
							<Grid item key={component?.id} sx={{ width: '20%' }}>
								<ComponentIcon component={component} projectId={projectId} />
							</Grid>
						)
					})}
			</Grid>
		</Box>
	)
}
